// Lightweight wrapper around Google Analytics 4 gtag.
// Fires no-op if gtag isn't loaded (e.g. local dev without GA env).
export function track(eventName, params = {}) {
  try {
    if (typeof window === "undefined") return;
    const g = window.gtag;
    if (typeof g !== "function") return;
    g("event", eventName, params);
  } catch (_) {
    // ignore — analytics must never break UX
  }
}

// Convenience helpers for the two key conversion events.
export function trackBookingCreated(booking) {
  if (!booking) return;
  track("booking_created", {
    transaction_id: booking.id,
    currency: "EUR",
    value: Number(booking.total_eur) || 0,
    module: booking.module,
    payment_method: booking.payment_method,
    payment_status: booking.payment_status,
  });
}

export function trackPaymentSuccess(booking) {
  if (!booking) return;
  const value = Number(booking.total_eur) || 0;
  track("payment_success", {
    transaction_id: booking.id,
    currency: "EUR",
    value,
    module: booking.module,
    payment_method: booking.payment_method || "card",
  });
  // GA4 standart ecommerce "purchase" event'i — Reports → Monetization → Purchases
  track("purchase", {
    transaction_id: booking.id,
    currency: "EUR",
    value,
    items: [{
      item_id: booking.item_id || booking.id,
      item_name: booking.item?.name || booking.item?.operator || booking.module,
      item_category: booking.module,
      price: value,
      quantity: 1,
    }],
  });
  // Google Ads conversion (Satın alma işlemi) — AW-11231819679/X17oCOfFr8UcEJ_v3-sp
  track("conversion", {
    send_to: "AW-11231819679/X17oCOfFr8UcEJ_v3-sp",
    value,
    currency: "EUR",
    transaction_id: booking.id || "",
  });
}
